unit ProductType;

interface

uses
  FileType, LocationType, SpecialismType, SupplierType, UserType, WeightScaleType;

type
  TProductType = class
  private
    fProductKey: String;
    fName: String;
    fSupplier: TSupplierType;
    fOrderNumber: String;
    fSpecifics: String;
    fSpecialism: TSpecialismType;
    fWeight: Single;
    fWeightScale: TWeightScaleType;
    fPrice: Single;
    fPicture: TFileType;
    fLocation: TLocationType;
    fStockAmount: Word;
    fActive: Boolean;
  public
    property ProductKey: String read fProductKey;
    property Name: String read fName;
    property Supplier: TSupplierType read fSupplier;
    property OrderNumber: String read fOrderNumber;
    property Specifics: String read fSpecifics;
    property Specialism: TSpecialismType read fSpecialism;
    property Weight: Single read fWeight;
    property WeightScale: TWeightScaleType read fWeightScale;
    property Price: Single read fPrice;
    property Picture: TFileType read fPicture;
    property Location: TLocationType read fLocation;
    property StockAmount: Word read fStockAmount;
    property Active: Boolean read fActive;
  end;


implementation

end.
